import { styled } from 'styled-components';

interface CardColumnProps {
  $span: 4 | 6 | 8 | 12;
}

/** The CardColumn component ensures that the layout scales appropriately when using
 * the Pretzel Cards.
 *
 * The Pretzel Cards have a min-width of 288px, and with our default page
 * width of 1080px, we can fit a maximum of 3 cards in a row.
 */
export const CardColumn = styled.div<CardColumnProps>`
  grid-column: span ${({ $span }) => $span};

  /** When the screen is smaller than 960px, there is only room for 2 cards in a row.
  The Column must therefore span at least 6 grid columns.
  288px * 3 columns + 24px gap * 2 + 24px page padding * 2 = 960px
  */
  @media (max-width: 960px) {
    grid-column: span ${({ $span }) => ($span === 12 || $span === 8 ? 12 : 6)};
  }

  /** When the screen is smaller than 648px, there is only room for 1 card in a row.
  The Column must therefore span all 12 grid columns.
  288px * 2 columns + 24px gap + 24px page padding * 2 = 648px */
  @media (max-width: 648px) {
    grid-column: span 12;
  }
`;
